export const MOOD_JOURNAL_GET_JOURNALS_BEGINS = 'MOOD_JOURNAL_GET_JOURNALS_BEGINS';
export const MOOD_JOURNAL_GET_JOURNALS_SUCCESS = 'MOOD_JOURNAL_GET_JOURNALS_SUCCESS';
export const MOOD_JOURNAL_GET_JOURNALS_FAILURE = 'MOOD_JOURNAL_GET_JOURNALS_FAILURE';
export const MOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR = 'MOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/mood-journal/redux/constants.js